<script>

import { mapState } from 'vuex'
import bus from 'vue3-eventbus'

export default {
  props: {
    data: Object
  },
  methods: {
    dismissDialog () {
      this.$emit('task')
    },
    showShareTips () {
      this.dismissDialog()
      this.$store.commit('shareTip', true)
    },
    open(){
      bus.emit('showNextTask', true)
    }
  },
  computed: {
    ...mapState(['finish_task_count'])
  },
  data () {
    return {
      taskPics: [require('@/assets/task_nomal.png'), require('@/assets/task_pass.png')],
      taskAward: [5, 5, 10, 15, 20],
      showClaim:false
    }
  }
}
</script>

<template>
  <div class="bg">
    <div class="title"></div>
    <div class="gold"></div>
    <div class="task-tips">Activating Advanced Rewards will earn<br>you rewards ranging from {{ data?.nextRoundsPopupTips }}.</div>
    <div class="task-reward">{{ data?.nextRoundsPopupTips }}</div>
    <div class="task-open" @click="open">Open</div>
  </div>
</template>

<style scoped>
.bg {
  width: 87.3rem;
  height: 66.2rem;
  align-self: start;
  background-image: url("@/assets/bg_open_nextround.png");
  background-size: 100% 100%;
  position: relative;
}
.title {
  width: 61.4rem;
  height: 8.6rem;
  background-image: url("@/assets/bg_advance_reward_title.png");
  background-size: 100% 100%;
  position: relative;
  align-self: center;
  justify-self: center;
  margin-top: 9rem;
}
.task-tips {
  color: #FFF;
  align-content: center;
  justify-content: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 49.2rem;
  height: 6.7rem;
  align-self: center;
  justify-self: center;
  margin-top: 1%;
  white-space: pre-wrap;
  text-align: center;
}
.gold {
  width: 73.7rem;
  height: 28.9rem;
  background-image: url("@/assets/bg_nextround_gold.png");
  background-size: 100% 100%;
  position: absolute;
  align-self: center;
  justify-self: center;
  margin-top: 30rem;
}
.task-reward {
  width: 30.7rem;
  height: 8rem;
  background-image: url("@/assets/bg_nextround_reward.png");
  background-size: 100% 100%;
  margin-top: 20rem;
  align-self: center;
  justify-self: center;
  color: #FFFF03;
  font-size: 4rem;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-weight: 800;
}
.task-open {
  width: 27.1rem;
  height: 8.6rem;
  background-image: url("@/assets/bg_nextround_open.png");
  background-size: 100% 100%;
  align-self: center;
  justify-self: center;
  color: #FFF;
  font-size: 2.8rem;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
}
</style>
